import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { checkAdminAuth } from '@/hooks/useAdminAuth';
import AdminSidebar from './AdminSidebar';

export default function AdminLayout() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!checkAdminAuth()) {
      navigate('/admin/login', { replace: true });
    }
  }, [navigate]);

  if (!checkAdminAuth()) return null;

  return (
    <div className="flex min-h-screen bg-[#F5F5F7]">
      <AdminSidebar />
      <main className="flex-1 min-w-0 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
